// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"d07337b4","599":"3bc10b19","629":"4929adf5","774":"15b645c6","787":"2c441f9b"}[chunkId] + ".chunk.js";
};